import React from 'react'
import Notification from '@ynap/notification'
import BEMHelper from '@ynap/bem-helper'

const bem = new BEMHelper('PartialReturnAlert')

type PartialReturnAlertProps = {
    messages: any
}

export default function PartialReturnAlert(props: PartialReturnAlertProps) {
    const {
        messages
    } = props
    const { telephone = '', email = '' } =
        (typeof window !== 'undefined' && window.SF?.getContactDetails?.()?.customerCare) || {}

    const phone = `<a href="tel:${telephone}">${messages.orderStatusDesc.phone()}</a>`
    const mail = `<a href="mailto:${email}">${messages.orderStatusDesc.email()}</a>`
    const message = <div data-testid="partial-return-alert" dangerouslySetInnerHTML={{ __html: messages.returnTracking.partialReturn({ phone, mail }) }} />

    return <Notification className={bem(null)} type="info" message="" messageChildren={message} />
}
